import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useMainEventColumn = () => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => params.data?.mainProjectName || '', []);

  return useMemo(
    () => ({
      field: 'mainProjectName',
      headerName: t('mainEvent'),
      cellClass: 'justify-start',
      minWidth: 120,
      valueGetter
    }),
    [t, valueGetter]
  );
};

export default useMainEventColumn;
